import { render, staticRenderFns } from "./addAbuse.vue?vue&type=template&id=c0c66fec&scoped=true&"
import script from "./addAbuse.vue?vue&type=script&lang=js&"
export * from "./addAbuse.vue?vue&type=script&lang=js&"
import style0 from "./addAbuse.vue?vue&type=style&index=0&id=c0c66fec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c66fec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0c66fec')) {
      api.createRecord('c0c66fec', component.options)
    } else {
      api.reload('c0c66fec', component.options)
    }
    module.hot.accept("./addAbuse.vue?vue&type=template&id=c0c66fec&scoped=true&", function () {
      api.rerender('c0c66fec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmTool/reportAbuse/components/addAbuse.vue"
export default component.exports